// src/encounter/lib/ambient-status-word.ts
//
// PROD-2962 · frame v2. What the ambient scribe is doing, in one word, for the collapsed Scrips
// Intelligence rail (D-41's 56px strip), so its status stays visible while the rail is closed.

import type { AmbientScribeBlockState } from '@scripsteam/scrips-signal-ds';

/** What the ambient scribe is doing, in a word, for the collapsed strip (nothing when it is at rest). */
export function ambientStatusWord(status: AmbientScribeBlockState | undefined, mounted: boolean): string | undefined {
  if (!mounted) return undefined;
  switch (status) {
    case 'recording':
      return 'Listening';
    case 'processing':
      return 'Drafting';
    case 'ready':
      return 'Ready';
    case 'failed':
      return 'Failed';
    default:
      return undefined;
  }
}
